import React, { useState, useRef } from "react";
import styled, { css } from "styled-components/macro";
import Product from "../components/Product";
import NavPin from "../components/NavPin"

const Sidebar = styled.div`
    position:absolute;
    z-index:2;
    ${props => props.isDesktop && css`
        width: 40rem;
        height:calc(100% - 20px);
        right:10px;
        top:10px;
    `}
    ${props => props.isDesktop && props.isActivePin && css`
        height:calc(100% - 45px);
        top:35px;
    `}
    ${props => !props.isDesktop && css`
        width: 100%;
        max-width:500px;
        margin: 0 auto;
        left: 0; 
        right: 0; 
        top: 25px;
        padding: 0 20px;
    `}
    ${props => !props.isDesktop && props.isActivePin && css`
        height:50vh;
        top:50vh;
        max-width:100%;
    `}
`

const Wrapper = styled.div`
    position:relative;
    width:100%;
    height:100%;
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
`

const NavigationModal = styled.div`
    width:100%;
    background:white;
    border-radius:5px;
    padding:5px 30px;

    overflow-y: auto;

    //Mobile with menu closed
    ${props => !props.isDesktop && !props.modalIsOpen && css`
        overflow:hidden;
        height:60px;
    `}

    //Mobile with menu open 
    ${props => !props.isDesktop && props.modalIsOpen && css`
        overflow-y: auto;
        height:auto;
        max-height:calc(100vh - 25px);
    
    `}

    //Desktop
    ${props => props.isDesktop && css`
        height:auto;
        padding:30px;
    `}
  

`

const NavTitle = styled.h2`
    font-family: 'GT America Extended', 'GT America', sans-serif;;
    font-style: normal;
    font-weight: 700;
    font-size: 2.6rem;
    line-height: 120%;
    color: #0C3E8D;
    margin:0;
    margin-bottom:8px;
`
const NavDesc = styled.div`
    font-family: 'GT America', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 2rem;
    line-height: 160%;
    color: #0B2957;
    padding-bottom:10px;
`
const NavSectionTitle = styled.div`
    position:relative;
    display:flex;
    align-items:center;
    margin-top:20px;
    margin-bottom:20px;
    &::before {
        position:absolute;
        content:"";
        top:calc(50% - 3px);
        height:5px;
        width:20px;
        left:-30px;
        background-color:#F0F3F8;
    }
`

const NavSectionTitle__Title = styled.div`
    font-weight:700;
    color:#0B2957;    
    font-size:2rem;
    flex-shrink:0;
`

const NavSectionTitle__Bar = styled.div`
    position:relative;
    margin-left:10px;
    height:5px;
    width:100%;
    background-color:#F0F3F8;
    top:1px;    
`

const NavSectionSubtitle = styled.div`
    font-weight:700;
    color:#5C6A83;
    font-size:1.8rem;
    margin-top:10px;
    margin-bottom:10px;
    @media(max-width: 768px){
        font-size: 2rem;
    }
    
`

const DesktopMenu = styled.div``

const MobileMenu = styled.div`

    position:relative;
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:center;

    z-index:2;
    height:50px;

    font-size:20px;
    color:#0B2957;
    font-weight:700;
    background-color:#fff;

    &:hover {
        cursor:pointer;
    }

`

const MobileTitle = styled.div`
    font-size:2.4rem;
`



export default function ProductContainer(props){

    const [ modalIsOpen, setModalIsOpen ] = useState(false)

    //Airtable approach
    let airtablePins = props.airtablePins; 

    // console.log("airtablePins ", airtablePins)
    // console.log("activePinNumber ", props.activePinNumber)

    function PinContent(){
        return (
            airtablePins.map((pinData, key) => {
                let data = pinData['fields']
                if (props.activePinNumber === data['Pin Number'] && data['Pin Type'] === 'Pin'){
                    return (
                        <Product 
                            key={data['Id']} 
                            content={data}
                            setActivePinNumber={props.setActivePinNumber}
                            isDesktop={props.isDesktop}
                        />
                    )
                }
            })
        )
    }

    function NavigationElements(){
        return (
            <>
            <NavSectionTitle><NavSectionTitle__Title>Generation</NavSectionTitle__Title><NavSectionTitle__Bar /></NavSectionTitle>
                            
                <NavSectionSubtitle>Nuclear</NavSectionSubtitle>
                <NavPin pinNumber={1} title="CANDU, PWR & BWR" handleClick={props.setActivePinNumber}/>
                <NavPin pinNumber={2} title="SMRs & Advanced Reactors" handleClick={props.setActivePinNumber}/>
                <NavPin pinNumber={3} title="Fusion" handleClick={props.setActivePinNumber}/>
                <NavPin pinNumber={4} title="Nuclear Infrastructure" handleClick={props.setActivePinNumber}/>
                <NavPin pinNumber={5} title="Medical Isotopes" handleClick={props.setActivePinNumber}/>

                <NavSectionSubtitle>Renewables</NavSectionSubtitle>
                <NavPin pinNumber={6} title="Hydro, Solar & Wind" handleClick={props.setActivePinNumber}/>

            <NavSectionTitle><NavSectionTitle__Title>Transmission & Distribution</NavSectionTitle__Title><NavSectionTitle__Bar /></NavSectionTitle>
                <NavPin pinNumber={7} title="Transmission" handleClick={props.setActivePinNumber}/>
                <NavPin pinNumber={8} title="Distribution" handleClick={props.setActivePinNumber}/>

            <NavSectionTitle><NavSectionTitle__Title>Enabling Technologies</NavSectionTitle__Title><NavSectionTitle__Bar /></NavSectionTitle>
                <NavPin pinNumber={9} title="Smart Grids" handleClick={props.setActivePinNumber}/>
                <NavPin pinNumber={10} title="Energy Storage" handleClick={props.setActivePinNumber}/>
                <NavPin pinNumber={11} title="Electric Vehicles" handleClick={props.setActivePinNumber}/>
                <NavPin pinNumber={12} title="Data Centers" handleClick={props.setActivePinNumber}/>
            </>
        )
    }

    return(
        <Sidebar isDesktop={props.isDesktop} isActivePin={props.activePinNumber}> 
            <Wrapper>
                { 
                    props.activePinNumber 
                    ?
                        <PinContent />
                    :
               
                        <NavigationModal isDesktop={props.isDesktop} modalIsOpen={modalIsOpen}>

                            { props.isDesktop ?
                                <DesktopMenu>
                                    <NavTitle>Energy & Infrastructure</NavTitle>
                                    <NavDesc>Click an item to start exploring</NavDesc>
                                </DesktopMenu>
                                :
                                <MobileMenu onClick={()=>setModalIsOpen(!modalIsOpen)}>
                                    {
                                        modalIsOpen ? 
                                        <>
                                            <MobileTitle>Close</MobileTitle>
                                            <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fillRule="evenodd" clipRule="evenodd" d="M14.6823 13.1377L25.4445 2.37549L23.6993 0.630249L12.937 11.3924L2.17487 0.630249L0.429749 2.37549L11.1919 13.1377L0.429749 23.8998L2.17487 25.6451L12.937 14.8829L23.6993 25.6451L25.4445 23.8998L14.6823 13.1377Z" fill="#F79A37"/>
                                            </svg>
                                        </>
                                        :
                                        <>
                                            <MobileTitle>Select an area of interest</MobileTitle>
                                            <svg width="23" height="12" viewBox="0 0 23 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M11.5 11.7588L0.674687 0.12086L22.3253 0.120862L11.5 11.7588Z" fill="#F79A37"/>
                                            </svg>
                                        </>
                                    }
                                    
                                </MobileMenu>
                            }

                            <NavigationElements />
                            
                        </NavigationModal>
                }
            </Wrapper>
        </Sidebar>
    )
}